import { lazy } from 'react';
import type { View, ViewParams } from '@/app/navigation/navigation-state';
import type { ViewRegistry } from '@/app/routing/view-registry';
import { useNavigation } from '@/app/navigation/use-navigation';

const ProjetosAtivos = lazy(() => import('@/features/projetos/components/ProjetosAtivos'));
const ProjetosEncerrados = lazy(() => import('@/features/projetos/components/ProjetosEncerrados'));
const ProjetoStatus = lazy(() => import('@/features/projetos/components/ProjetoStatus'));

function ProjetosAtivosView() {
  const { viewParams, actions } = useNavigation();
  return (
    <ProjetosAtivos
      onBack={actions.goBack}
      onNavigateToView={(view: string, params?: unknown) => {
        actions.navigate(view as View, {
          viewParams: (params as ViewParams | null | undefined) ?? null,
        });
      }}
      // ProjetosAtivos declares returnState: Record<string, any>; we pass the
      // viewParams.returnState through as-is (loose shape, legacy contract).
      returnState={viewParams?.returnState as Record<string, unknown> | undefined}
      initialOpenRecordId={viewParams?.initialOpenRecordId}
      onClearReturnState={() => actions.setViewParams(null)}
    />
  );
}

function ProjetosEncerradosView() {
  const { actions } = useNavigation();
  return (
    <ProjetosEncerrados
      onBack={actions.goBack}
      onNavigateToView={(view: string, params?: unknown) => {
        actions.navigate(view as View, {
          viewParams: (params as ViewParams | null | undefined) ?? null,
        });
      }}
    />
  );
}

function ProjetoStatusView() {
  const { actions } = useNavigation();
  return <ProjetoStatus onBack={actions.goBack} />;
}

export const projetosViews: Partial<ViewRegistry> = {
  'projetos-ativos': { component: ProjetosAtivosView, guard: {} },
  'projetos-encerrados': {
    component: ProjetosEncerradosView,
    guard: { screen: 'projetos-encerrados' },
  },
  'projeto-status': { component: ProjetoStatusView, guard: { screen: 'projeto-status' } },
};
